import { cn } from "@/shared/lib/cn";

export interface CategoryChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

/**
 * Un chip de categoría.
 *
 * No usa el `Button` del sistema a propósito: los chips de un filtro son
 * un GRUPO de opciones excluyentes, no acciones sueltas. Lo que los
 * distingue es `aria-pressed`, que dice cuál está puesto — un `Button`
 * con `variant="dark"` se vería igual pero un lector de pantalla no
 * sabría cuál de los seis está activo, y el color no basta.
 */
export function CategoryChip({ label, selected, onClick }: CategoryChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        "rounded-ds-pill px-4 py-2 text-[12px] font-semibold tracking-wide transition-all duration-300",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-violet-pop/50 focus-visible:ring-offset-2 focus-visible:ring-offset-ds-cream",
        selected
          ? "bg-ds-ink text-white shadow-ds-card"
          : "border border-ds-border bg-white text-ds-ink-3 hover:border-ds-violet-pop hover:text-ds-violet-pop",
      )}
    >
      {label}
    </button>
  );
}
